export default {
  API_URL: 'https://nextdecade-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://nextdecadesandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
